import React, { useContext } from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperiences,
  skillsSection,
  blogSection,
  talkSection,
  achievementSection,
  resumeSection,
} from "../../portfolio";

function Header({ showNavigation }) {
  const { isDark } = useContext(StyleContext);
  const viewExperience = workExperiences.display;
  const viewSkills = skillsSection.display;
  const viewAchievement = achievementSection.display;
  const viewBlog = blogSection.display;
  const viewTalks = talkSection.display;
  const viewResume = resumeSection.display;

  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/" className="logo">
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{ color: "white" }}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {showNavigation && viewSkills && (
            <li>
              <a href="#skills">Skills</a>
            </li>
          )}
          {showNavigation && viewExperience && (
            <li>
              <a href="#experience">Work Experiences</a>
            </li>
          )}
          {showNavigation && viewAchievement && (
            <li>
              <a href="#achievements">Achievements</a>
            </li>
          )}
          {showNavigation && viewBlog && (
            <li>
              <a href="#blogs">Blogs</a>
            </li>
          )}
          {showNavigation && viewTalks && (
            <li>
              <a href="#talks">Talks</a>
            </li>
          )}
          {showNavigation && viewResume && (
            <li>
              <a href="#resume">Resume</a>
            </li>
          )}
          {showNavigation && (
            <li>
              <a href="#contact">Contact Me</a>
            </li>
          )}
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
